import React from 'react'
import WorkFlowMessagesContainer from './Messages/WorkFlowMessagesContainer'

export default function WorkFlowMessagesSection({ event,messages }) {
  return (
    <WorkFlowMessagesContainer messages={messages} event={event} />
  )
}
